import type { Match } from "navigo";
import type { ChildDom } from "vanjs-core";
import { reactive } from "vanjs-ext";
import type { Route, RouteContext } from "../router";
import { centeredBox } from "../van/centered-box";
import { button, div, h1, p } from "../van/van-tags";

export class Sp2CmdGetStatusPage implements Route {
	async #onClickSend(): Promise<void> {
		const req = this.#ctx.api.post(
			`/smartplug2s/${this.#reactive.imei}/cmds`,
		);
		req.setJsonBody({
			CmdType: 0xa2,
		});
		req.setSignedInUserAuth();

		const res = await this.#ctx.loadingScreen.waitFor(req.do());
		if (res.ok) {
			this.#ctx.router.up();
		} else {
			this.#ctx.error.setText(await res.text());
		}
	}

	async refresh(match: Match): Promise<void> {
		if (!match.data?.imei) throw "missing path param: imei";
		this.#reactive.imei = match.data.imei;
	}

	#ctx: RouteContext;
	#reactive = reactive({
		imei: "",
	});

	ChildDom: ChildDom;

	constructor(ctx: RouteContext) {
		this.#ctx = ctx;
		this.ChildDom = centeredBox(
			{ size: "narrow" },
			h1({ class: "title is-4" }, "SmartPlug2 - Get Status"),
			p({ class: "subtitle is-6" }, () => `IMEI ${this.#reactive.imei}`),
			div(
				{ class: "buttons" },
				button(
					{
						class: "button is-primary",
						onclick: () => this.#onClickSend(),
					},
					"Send command",
				),
				button(
					{
						class: "button is-danger",
						onclick: () => this.#ctx.router.up(),
					},
					"Back",
				),
			),
		);
	}
}
